import styled from '@emotion/styled';
import { DataFieldProps } from 'packages/formidable/components/Data/props';
import FormidableContext from 'packages/formidable/FormidableContext';
import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { WrappedFieldProps } from 'redux-form';

import { FieldTemplate } from '~/components/Field';

const FieldMessageSC = styled.div<{ color?: string }>``;

const FieldTemplateComponent: FC<WrappedFieldProps & DataFieldProps> = ({
  children,
  customAction,
  customActionProps,
  message,
  type,
  templateProps,
  meta: { error, touched, warning },
}) => {
  const { t } = useTranslation();
  const { sc } = useContext(FormidableContext);

  return (
    <>
      <FieldTemplate {...templateProps} type={type}>
        {children}

        {customAction && <div {...customActionProps}>{customAction}</div>}
      </FieldTemplate>
      {touched &&
        ((error && (
          <FieldMessageSC as={sc && sc.fieldMessage} color="error">
            {t ? t(error) : error}
          </FieldMessageSC>
        )) ||
          (warning && (
            <FieldMessageSC as={sc && sc.fieldMessage} color="warning">
              {t ? t(warning) : warning}
            </FieldMessageSC>
          )))}
      {message && (
        <FieldMessageSC as={sc && sc.fieldMessage}>
          {t ? t(message) : message}
        </FieldMessageSC>
      )}
    </>
  );
};

export default FieldTemplateComponent;
